import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Search, Wrench, Eye, Edit, Car } from "lucide-react";
import { motion } from "framer-motion";

const accidentalCars = [
  { id: 1, name: "Honda City 2022", damage: "Front Collision", partsReplaced: 5, repairCost: "₨ 450,000", status: "Repaired", purchasePrice: "₨ 2,800,000" },
  { id: 2, name: "Toyota Corolla 2021", damage: "Side Impact", partsReplaced: 3, repairCost: "₨ 280,000", status: "Under Repair", purchasePrice: "₨ 3,200,000" },
  { id: 3, name: "Suzuki Swift 2023", damage: "Rear Collision", partsReplaced: 4, repairCost: "₨ 350,000", status: "Repaired", purchasePrice: "₨ 2,500,000" },
];

const AccidentalCars = () => {
  return (
    <Layout title="Accidental Cars">
      <div className="space-y-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <h1 className="text-2xl font-display font-bold text-foreground">Accidental Cars</h1>
            <p className="text-sm text-muted-foreground mt-1">Track accidental vehicles, parts replaced, and repair costs</p>
          </div>
          <Button variant="premium" className="gap-2"><Plus className="w-4 h-4" /> Add Accidental Car</Button>
        </div>

        <div className="relative max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input placeholder="Search accidental cars..." className="glass-input pl-9 h-10" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {accidentalCars.map((car, i) => (
            <motion.div key={car.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }} className="glass-card p-5 space-y-4">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-destructive/10 flex items-center justify-center">
                    <Wrench className="w-5 h-5 text-destructive" />
                  </div>
                  <div>
                    <h3 className="font-display font-semibold text-foreground text-sm">{car.name}</h3>
                    <p className="text-xs text-muted-foreground">{car.damage}</p>
                  </div>
                </div>
                <span className={`text-xs px-2.5 py-1 rounded-full font-medium ${car.status === "Repaired" ? "bg-success/10 text-success" : "bg-warning/10 text-warning"}`}>{car.status}</span>
              </div>

              <div className="grid grid-cols-2 gap-3 text-sm">
                <div className="p-3 rounded-lg bg-secondary/30">
                  <p className="text-xs text-muted-foreground">Purchase Price</p>
                  <p className="font-medium text-foreground">{car.purchasePrice}</p>
                </div>
                <div className="p-3 rounded-lg bg-secondary/30">
                  <p className="text-xs text-muted-foreground">Repair Cost</p>
                  <p className="font-medium text-destructive">{car.repairCost}</p>
                </div>
                <div className="p-3 rounded-lg bg-secondary/30">
                  <p className="text-xs text-muted-foreground">Parts Replaced</p>
                  <p className="font-medium text-foreground">{car.partsReplaced}</p>
                </div>
                <div className="p-3 rounded-lg bg-secondary/30">
                  <p className="text-xs text-muted-foreground">Total Investment</p>
                  <p className="font-medium text-primary">₨ {(parseInt(car.purchasePrice.replace(/[^\d]/g, '')) + parseInt(car.repairCost.replace(/[^\d]/g, ''))).toLocaleString()}</p>
                </div>
              </div>

              <div className="flex items-center gap-2 pt-2 border-t border-border/30">
                <Button variant="glass" size="sm" className="flex-1 gap-1.5 text-xs h-8"><Eye className="w-3 h-3" /> View Parts</Button>
                <Button variant="glass" size="sm" className="flex-1 gap-1.5 text-xs h-8"><Edit className="w-3 h-3" /> Edit</Button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default AccidentalCars;
